import React, { PureComponent } from 'react'
import Button from 'aria-viewer/tour/components/buttons/button'
import SVG from 'public/assets/svg/icons/raw/icon_close.raw.svg'

class CloseButton extends PureComponent {
    getIcon() {
        if (this.props.puresvg) {
            return null
        }

        return <div style={this.props.svgStyle} dangerouslySetInnerHTML={{ __html: SVG }} />
    }

    render() {
        const { onClick, style, theme, children, labelStyle, puresvg = false, tabIndex, className } = this.props

        return (
            <Button
                className={className}
                onClick={onClick}
                style={style}
                labelStyle={labelStyle}
                theme={theme || 'button_transparent'}
                tabIndex={tabIndex}
                icon="close"
                puresvg={puresvg}
                alt="close"
                svgStyle={this.props.svgStyle}
            >
                {children}
            </Button>
        )
    }
}

export default CloseButton
